'use strict';


module.exports = function (client) {

    client.getPrivateData = function (opts, cb) {
        return this.sendIq({
            type: 'get',
            privateStorage: opts
        }, cb);
    };

    client.setPrivateData = function (opts, cb) {
        return this.sendIq({
            type: 'set',
            privateStorage: opts
        }, cb);
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/stanza.io/lib/plugins/private.js
// module id = 342
// module chunks = 0